<template>
  <div style="position: relative;">
    <v-toolbar class="primary elevation-0 small-extension imoveis-toolbar" dark>
      <h1 class="titulo titulo-imoveis">Imóveis</h1>
      <div class="opcoes_lista_mapa opcoes_lista_mapa_mobile">
        <router-link :to="{ name: 'ImoveisLista' }">
          <v-btn flat :ripple="false" class="opcao-view-btn">
            <v-icon class="mr-1">list</v-icon> Lista
          </v-btn>
        </router-link>
        <router-link :to="{ name: 'ImoveisMapa' }">
          <v-btn flat :ripple="false" class="opcao-view-btn">
            <v-icon class="mr-1">room</v-icon> Mapa
          </v-btn>
        </router-link>
      </div>
    </v-toolbar>
    <gmap-map
      :center="center"
      :zoom="currentZoom"
      ref="map"
      :options="{ clickableIcons: false, streetViewControl: false, fullscreenControl: false, minZoom: 7, maxZoom: 17, zoomControlOptions: { position: zoomPosition } }"
      style="width: 100%; height: calc(100vh - 142px)"
      @bounds_changed="updateBounds($event)"
      @zoom_changed="updateZoom($event)"
      @idle="idleLoadImoveis"
    >
      <gmap-marker
        :position="{ lat: coords.latitude, lng: coords.longitude }"
        :clickable="false"
        :icon="currentLocationIcon"
      >
      </gmap-marker>
      <gmap-marker
        v-for="(item, index) in imoveis"
        v-if="item.endereco !== undefined"
        :key="item.id"
        :ref="'marker' + item.id"
        :position="{ lat: item.endereco.data.latitude, lng: item.endereco.data.longitude }"
        :icon="getIcon(item)"
        :clickable="true"
        @click="clickMarker(item)"
      >
      </gmap-marker>
      <mapa-info-window :marker="infoWindowMarker" :imovel="infoWindowImovel" :is-open="infoWindowOpened" v-if="infoWindowOpened" :key="infoWindowImovel.id"></mapa-info-window>
    </gmap-map>
    <v-layout row wrap class="mapa_botoes">
      <transition name="scale-transition">
        <v-flex xs12 sm5 md4 class="mb-2 legenda-card-col" v-if="legenda">
          <v-card class="pa-3">  
            <div class="subheading secondary--text uppercase text-xs-center mb-4"><strong>Status</strong></div>
            <div class="text-xs-right legenda_cores">
              <div>Sem status <span class="legenda_cor" :style="{ 'background-color': colors.undefined }"></span></div>
              <div v-for="(item, index) in colors" :key="index" v-if="index !== 'undefined'" class="my-3">{{ index }} <span class="legenda_cor" :style="{ 'background-color': item }"></span></div>
            </div>
          </v-card>
        </v-flex>
      </transition>
      <v-flex xs12 sm3 md2 class="legenda-btn-col">
        <v-btn large block class="white secondary--text legenda-btn" @click.native="legenda = !legenda">Legenda</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import HeadersMapa from './Headers/HeadersMapa'
  import MapaInfoWindow from './Mapa/MapaInfoWindow'
  import _ from 'lodash'

  export default {
    components: {
      HeadersMapa,
      MapaInfoWindow
    },
    data () {
      return {
        unsubscribe: null,
        /* eslint-disable */
        currentLocationIcon: {
          url: 'static/current_location_marker.png',
          scaledSize: new google.maps.Size(16, 16)
        },
        zoomPosition: google.maps.ControlPosition.RIGHT_TOP,
        /* eslint-enable */
        infoWindowOpened: false,
        infoWindowMarker: null,
        infoWindowImovel: null,
        mapBounds: {},
        currentZoom: 14,
        colors: {
          undefined: 'grey',
          Vago: '#EDC109',
          Compromissado: '#EA5DDF',
          Locado: '#4FBF46',
          Comodato: '#006AB6',
          Invadido: '#ED1B09'
        },
        legenda: false,
        center: {
          lat: this.$store.getters['utils/coords'].latitude,
          lng: this.$store.getters['utils/coords'].longitude
        }
      }
    },
    computed: {
      imoveis: {
        get: function () {
          return this.$store.getters['imoveis/lista']
        },
        set: function () {}
      },
      coords () {
        return this.$store.getters['utils/coords']
      },
      filtros () {
        return this.$store.getters['imoveis/filtros']
      },
      isRetrievingCoords () {
        return this.$store.getters['utils/isRetrievingCoords']
      }
    },
    watch: {
      isRetrievingCoords () {
        this.center.lat = this.coords.latitude
        this.center.lng = this.coords.longitude
      }
    },
    mounted () {
      this.clearImoveis()
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'imoveis/SET_FILTROS') {
          this.clearImoveis()
          this.loadImoveis()
        }
      })
    },
    beforeDestroy () {
      this.unsubscribe()
    },
    methods: {
      getIcon (imovel) {
        /* eslint-disable */
        let fillColor = this.colors.undefined
        if (imovel.status !== undefined) {
          fillColor = this.colors[imovel.status.data.status]
        }

        return {          
          path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
          fillColor: fillColor,
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 1,
          scale: 1
        }
        /* eslint-enable */
      },
      openRightNav () {
        this.$store.dispatch('template/setRightNav', true)
      },
      clickMarker (item) {
        this.infoWindowMarker = this.$refs['marker' + item.id][0].$markerObject
        this.infoWindowImovel = item
        this.infoWindowOpened = true
      },
      updateBounds (event) {
        this.$store.dispatch('template/setLeftNav', false)
        if (this.isRetrievingCoords) {
          return
        }
        this.mapBounds = event
      },
      updateZoom (event) {
        this.currentZoom = event
      },
      clearImoveis () {
        this.$store.dispatch('imoveis/clearLista')
      },
      idleLoadImoveis () {
        this.loadImoveis()
      },
      loadImoveis () {
        if (this.isRetrievingCoords) {
          return
        }

        if (this.currentZoom < 10) {
          return
        }

        const payload = {}

        if (!_.isEmpty(this.filtros)) {
          Object.assign(payload, this.filtros)
          // delete payload.uf
          // delete payload.cidade
          // delete payload.bairro
        }

        payload.loading = false
        payload.parametro = 'coords'
        payload.sw_lat = this.mapBounds.getSouthWest().lat()
        payload.sw_lng = this.mapBounds.getSouthWest().lng()
        payload.ne_lat = this.mapBounds.getNorthEast().lat()
        payload.ne_lng = this.mapBounds.getNorthEast().lng()
        payload.center_lat = this.mapBounds.getCenter().lat()
        payload.center_lng = this.mapBounds.getCenter().lng()
        payload.zoom = this.currentZoom

        this.$store.dispatch('imoveis/loadLista', payload)
      }
    }
  }
</script>

<style>
  a[href^="http://maps.google.com/maps"]{display:none !important}
  a[href^="https://maps.google.com/maps"]{display:none !important}
  .btn__content:before { opacity: 0; }

  .gmnoprint a, .gmnoprint span, .gm-style-cc { display: none; }
</style>

<style scoped>
  .mapa_botoes { position: absolute; bottom: 10px; left: 4px; z-index: 2; width: 100%; -webkit-transition: opacity .3s ease-in-out; -moz-transition: opacity .3s ease-in-out; -ms-transition: opacity .3s ease-in-out; -o-transition: opacity .3s ease-in-out; }
  .mapa_botoes .uppercase { text-transform: uppercase; }
  .legenda_cores .legenda_cor { display: inline-block; height: 18px; width: 18px; border-radius: 100%; line-height: 10px; vertical-align: middle; margin: 0 7px; }

  .legenda-btn-col {
    margin-left: auto;
    max-width: 180px;
  }

  @media (max-width: 959px) {
    .imoveis-toolbar {
      height: auto !important;
      min-height: 64px;
      padding-top: 8px;
      padding-bottom: 10px;
      align-items: flex-start;
    }

    .titulo-imoveis {
      width: 100%;
      text-align: left;
      font-size: 24px;
      padding-left: 12px;
    }

    .opcoes_lista_mapa_mobile {
      position: static !important;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      padding-left: 8px;
      margin-top: 2px;
    }

    .opcoes_lista_mapa_mobile .btn {
      margin-left: 0 !important;
      margin-right: 6px !important;
      min-width: 0;
    }

    .opcao-view-btn .btn__content {
      padding: 0 8px !important;
    }

    .mapa_botoes {
      left: 0;
      right: 0;
      width: auto;
      padding: 0 10px;
      bottom: 12px;
    }

    .legenda-card-col {
      margin-bottom: 8px;
    }

    .legenda-btn-col {
      max-width: 220px;
      margin-left: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// ImoveisMapa.vue?79791316